import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

const buildQuery = ({ dataset }: { dataset: string }) => ({
  query: gql`
    query getTargetFields($dataType: String!) {
      getTargetFields(dataType: $dataType)
    }
  `,
  variables: {
    dataType: dataset,
  },
});

const getTargetFields = async (
  client: ApolloClient<NormalizedCacheObject>,
  dataset: string,
): Promise<string[]> => {
  const query = buildQuery({ dataset });
  const response = await client.query(query);
  return response.data.getTargetFields;
};

export default getTargetFields;
